import instance from "@/services/api";

export const loggingAPI = {
  async activateLogging(body) {
    return instance(true).post('/common/smart_debug/activate/', body)
  },
  async getLogs() {
    return instance(true).get('/common/smart_debug/read/')
  }
}